var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "h-full relative" }, [
    _c(
      "a",
      {
        staticClass: "block",
        attrs: {
          href: _vm.data.permalink,
          "data-id": _vm.data.postid,
          id: "event-card"
        },
        on: {
          mouseover: function($event) {
            _vm.hover = true
          },
          mouseleave: function($event) {
            _vm.hover = false
          }
        }
      },
      [
        _c("div", { staticClass: "details-thumbnail" }, [
          _c("div", {
            staticClass:
              "details-image fixed-ratio-image bg-transparent bg-cover bg-no-repeat",
            style: "background-image: url(" + _vm.data.image + ")"
          }),
          _vm._v(" "),
          _vm.data.tickets_sales_start
            ? _c("div", [
                _vm.data.ticketstatus === "beschikbaar"
                  ? _c("img", {
                      staticClass: "ticket-label",
                      attrs: { src: _vm.beschikbaarLabel, alt: "" }
                    })
                  : _vm.data.ticketstatus === "uitverkocht"
                  ? _c("img", {
                      staticClass: "ticket-label",
                      attrs: { src: _vm.uitverkochtLabel, alt: "" }
                    })
                  : _vm._e()
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "details-content bg-white text-thunderBlack pt-5 pb-8 "
          },
          [
            _c("div", {
              staticClass: "font-semib w-20old text-lg mb-5",
              domProps: { innerHTML: _vm._s(_vm.data.title) }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "flex justify-between items-center" }, [
              _c(
                "div",
                {
                  staticClass: "details-dates flex items-center",
                  attrs: { id: "" }
                },
                [
                  _vm.data.dates !== ""
                    ? _c("div", { staticClass: "flex justify-start w-7" }, [
                        _c("img", {
                          attrs: { src: _vm.dateIconHover, alt: "" }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data.dates !== ""
                    ? _c("div", { staticClass: "ml-3" }, [
                        _c("span", { staticClass: "capitalize text-sm" }, [
                          _vm._v(" " + _vm._s(_vm.data.dates) + " ")
                        ])
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex items-center -mx-1" },
                _vm._l(_vm.data.details, function(detail, index) {
                  return _c("div", { key: index, staticClass: "px-1" }, [
                    detail === "betaald"
                      ? _c("div", [
                          _c("img", {
                            staticClass: "w-4 h-4",
                            attrs: {
                              src: require("../../images/icon-betaald2.svg"),
                              alt: ""
                            }
                          })
                        ])
                      : detail === "engelstalig"
                      ? _c("div", [
                          _c("img", {
                            staticClass: "w-4 h-4",
                            attrs: {
                              src: require("../../images/icon-engelstalig.svg"),
                              alt: ""
                            }
                          })
                        ])
                      : detail === "identificatie"
                      ? _c("div", [
                          _c("img", {
                            staticClass: "w-4 h-4",
                            attrs: {
                              src: require("../../images/icon-identificatie.svg"),
                              alt: ""
                            }
                          })
                        ])
                      : detail === "testen_voor_toegang"
                      ? _c("div", [
                          _c("img", {
                            staticClass: "w-4 h-4",
                            attrs: {
                              src: require("../../images/icon-testen_voor_toegang.svg"),
                              alt: ""
                            }
                          })
                        ])
                      : detail === "rolstoelvriendelijk"
                      ? _c("div", [
                          _c("img", {
                            staticClass: "w-4 h-4",
                            attrs: {
                              src: require("../../images/icon-rolstoelvriendelijk.svg"),
                              alt: ""
                            }
                          })
                        ])
                      : _vm._e()
                  ])
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "details-dates flex items-center mt-1",
                attrs: { id: "" }
              },
              [
                _c("div", { staticClass: "flex justify-start w-6" }, [
                  _vm.data.time !== "no_specific_time"
                    ? _c("img", { attrs: { src: _vm.timeIconHover, alt: "" } })
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ml-2" }, [
                  _vm.data.time !== "no_specific_time"
                    ? _c("span", { staticClass: "text-sm" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.data.time) +
                            "\n          "
                        )
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _vm.data.location !== ""
              ? _c(
                  "div",
                  {
                    staticClass: "details-location flex items-center mt-1",
                    attrs: { id: "" }
                  },
                  [
                    _c("div", { staticClass: "flex justify-start w-6" }, [
                      _c("img", {
                        attrs: { src: _vm.locationIconHover, alt: "" }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "ml-2" }, [
                      _c("span", { staticClass: "text-sm" }, [
                        _c("a", { staticClass: "no-underline" }, [
                          _vm._v(_vm._s(_vm.data.location))
                        ])
                      ])
                    ])
                  ]
                )
              : _vm._e()
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c("a", {
      staticClass: "absolute bottom-0 right-0 favcard",
      class: { "favcard-active": this.isFavourite },
      on: { click: _vm.favourite }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/reshmirav/devilbox/data/www/whd/whd/wp-content/themes/wereldhavendagen/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/reshmirav/devilbox/data/www/whd/whd/wp-content/themes/wereldhavendagen/node_modules/vue-loader/lib?{}!./scripts/vue/EventCard.vue?vue&type=template&id=801e5074&
// module id = 77
// module chunks = 0